module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH-1"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#cpyntc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epigraphs#epig",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Epigraphs")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/authorsnote#ant"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH__TOP"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#pro"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Prologue: Wildsview")])])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("PART I: DISPATCHER: OUTWARD BOUND")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Closed City")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Treasure Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("Tompkins’s Folly")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4"
    }
  }, [_vm._v("In Search of the South African "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Hüzün")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zita’s Map of Želva")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Ulysses")]), _vm._v(" Is About Us”")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forests of the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wall of Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Venus de Milo ‘Suspect’”")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yidden")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sandspruit")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bird’s-eye View")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Fringe Country”")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Psychopathia Sexualis")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Xai-Xai")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fischer Pool on Beaumont Street")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fort")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Town")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Bells")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Jim Comes to Joburg")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Third Basement")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Underground Underworld")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bachelors and Maidens")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spyglass Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Umtshotsho")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edenvale")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ballad of Phil and Edgar")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ultimate Dispatcher")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The Venice of the South”")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ecstasy of Immersion")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wilds")])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("PART II: ATTACK")])])]), _vm._v(" "), _c('p', {
    staticClass: "CPT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("PART III: DISPATCHER: HOMEWARD BOUND")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope in Alexandra")])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Open City”")])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/illustration#ill",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Illustration Credits")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/noteaboutauthor#ants",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Note About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Also by Mark Gevisser")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0